import React from 'react'
import { TextField } from '@material-ui/core';

export default function TextBox({ value, onChange, rows, label }) {
    return (
        <TextField
            id="outlined-multiline-static"
            multiline
            rows={rows}
            value={value}
            variant="outlined"
            name="letterhead"
            onChange={(e, value) => onChange(value)}
            style={{ width: '100%' }}
            label={label}
        />
    )
}
